module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadingTab) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем настройки уведомлений..."
    }
  }) : _c('div', [(_vm.settingsActions.length > 0) ? _c('table', {
    staticClass: "table table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Событие")]), _vm._v(" "), _vm._l((_vm.settingsChannels), function(channel) {
    return _c('th', [_vm._v(_vm._s(channel.name))])
  })], 2)]), _vm._v(" "), (_vm.settingsActions) ? _c('tbody', _vm._l((_vm.settingsActions), function(action) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(action.name))]), _vm._v(" "), _vm._l((_vm.getSettingsByAction(action)), function(setting) {
      return _c('td', [_c('label', {
        staticClass: "switch switch-lg switch-3d switch-primary"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (setting.value),
          expression: "setting.value"
        }],
        staticClass: "switch-input",
        attrs: {
          "disabled": _vm.loading,
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(setting.value) ? _vm._i(setting.value, null) > -1 : (setting.value)
        },
        on: {
          "change": [function($event) {
            var $$a = setting.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (setting.value = $$a.concat([$$v]))
              } else {
                $$i > -1 && (setting.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.$set(setting, "value", $$c)
            }
          }, function($event) {
            _vm.changeSetting(setting)
          }]
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-label"
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-handle"
      }), _vm._v(" "), (setting.value) ? _c('small', [_vm._v("включено")]) : _c('small', [_vm._v("выключено")])])])
    })], 2)
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Обновляем настройки..."
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5190bd4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-a5190bd4"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/ProfileNotificationSettings.vue
// module id = 1064
// module chunks = 1